import * as React from "react";
import type { SVGProps } from "react";
const SvgBatchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="batch_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M341.333 128A42.667 42.667 0 0 1 384 85.333h256a42.667 42.667 0 1 1 0 85.334H384A42.667 42.667 0 0 1 341.333 128zM256 213.333a42.667 42.667 0 0 0 0 85.334h512a42.667 42.667 0 1 0 0-85.334H256zm0 128A170.667 170.667 0 0 0 85.333 512v256A170.667 170.667 0 0 0 256 938.667h512A170.667 170.667 0 0 0 938.667 768V512A170.667 170.667 0 0 0 768 341.333H256zM170.667 512A85.333 85.333 0 0 1 256 426.667h512A85.333 85.333 0 0 1 853.333 512v256A85.333 85.333 0 0 1 768 853.333H256A85.333 85.333 0 0 1 170.667 768V512zm490.922 72.832a42.667 42.667 0 0 0-60.33-60.33L482.133 643.668 422.7 584.235a42.667 42.667 0 0 0-60.331 60.33l89.6 89.6a42.667 42.667 0 0 0 60.33 0l149.334-149.333z"
    />
  </svg>
);
export default SvgBatchIcon;
